const se = {
  lead: "Bearrašat, vánddardeaddjit, čuoigit ja turisttat čuvvot stáluid vázzil, sabehiiguin ja fatnasiin. Bija stáluid du uvssa lusa, de bivdu doalvu ođđa guossiid njuolgga du lusa — beroškeahttá makkár báikki don doalat.",
  areasKicker: "Surggit",
  areasTitle: "Gávnna du suorggi.",
  bannerKicker: "Leago dus fitnodat dán surggis?",
  bannerTitle: "Oaččo eanet kundáriid. Geasut ođđa gallededdjiid.",
  cta: "Šatta Trollfossjakten-guoibmin",
  placesLike: "Báikkit nugo",
  ideaTitle: "Stáluidea",
  cats: {
    hotels: {
      name: "Hotealat ja hotealaráiddut",
      short: "Dagat stálubivdiid idjadeaddji guossiide.",
      lead: "Stállu uvssa luhtte, gárddis dahje hotealla iežas bálgá alde addá bearrašiidda siva orrut ija — ja boahtit fas boahtte áigodagas.",
      idea: "Guoddistállu mii guoddá vádjaliid uvssa luhtte, iđitbiebmostállu buffealáse luhtte ja ijastállu guovssahasaid vuolde dáhkketerássas.",
      types: ["Hotealaráiddut", "Historjjálaš hotealat", "Vuotna- ja duottarhotealat", "Resorttat ja spáhotealat", "Riddohotealat", "Hyttat ja lodget"],
    },
    restaurants: {
      name: "Restoránat ja kaféaráiddut",
      short: "Nelgon bivdit, njuolgga du uvssa olggobealde.",
      lead: "Stálubivdu dahká olbmuid nelgon. Bija stáluid restoránaid lusa, ja divtte speallid diŋgot ovdagihtii ja máksit Vippsain mátkkis.",
      idea: "Gokkastállu mii sorbme mális, pizzastállu terássas ja kaffestállu mii várjala buoremus láseoasi.",
      types: ["Pizza- ja burgerráiddut", "Kaffeáraiddut", "Steakhouset", "Bearašrestoránat", "Sushi ja ásialaš borramuš", "Láibbohatráiddut"],
    },
    activities: {
      name: "Doaimmat ja vásáhusat",
      short: "Atte heakkaheaddjiide vel ovtta siva diŋgot.",
      lead: "Vuotnamátkkit, rafting, safárit ja oahpistuvvon vánddardeamit leat buorre stálueana. Du stálut dahket mátkki bargun — ja dolvot speallid du diŋgonbeavddi lusa.",
      idea: "Gádjunliivvastállu kajakkašalddi luhtte, jiekŋastállu jieŋa alde ja guovssahasstállu mii čájeha iežas dušše dálvesafáriin.",
      types: ["Vuotnamátkkit ja cruisat", "Riddomátkkit", "Rafting ja kajakka", "Árktalaš safárit ja guovssahasat", "Heakkamátkkit", "Meahcceguovddážat"],
    },
    ski: {
      name: "Čuoiganguovddážat ja duottarbáikkit",
      short: "Stálut lusttain, olles dálvvi.",
      lead: "Stálut lofttaid luhtte, čuoigaláđđasis ja alladievá kaféas dahket juohke čuoiganbeaivvi bivdun — ja bearrašat bohtet fas maiddái geasset.",
      idea: "Čuoigistállu boares muorrasabehiiguin lofta luhtte, muohtastállu vuovdeláđđasis ja dievvástállu mii addá liekkus kakáo.",
      types: ["Alpiinaguovddážat", "Čuoigaláđđasguovddážat", "Duottargilážat", "Geassečuoigan", "Afterski ja lodget", "Čuoigaskuvllat"],
    },
    attractions: {
      name: "Geahččanveara báikkit ja museat",
      short: "Divtte stáluid muitalit du historjjá.",
      lead: "Stálut gullet norgga álbmotmuitalusaide. Bija daid museaparkii, stávvaggirku lusa dahje dovddus vánddardanbálgá guoras, de galledeaddjit orrot guhkit ja guorahallet eambbo.",
      idea: "Muitalanstállu boares dálu luhtte, dragonoaivestállu stávvaggirku alde ja báktestállu mii várjala geahččanbáikki.",
      types: ["Olgomuseat", "Fanas- ja historjámuseat", "Dáiddamuseat", "Stávvaggirkut ja katedrálat", "Álbmotmeahcit", "Dovddus vánddardeamit ja geahččanbáikkit"],
    },
    transport: {
      name: "Johtolat ja fearjját",
      short: "Daga mátkki oassin bivddus.",
      lead: "Fearjját, jođánisfatnasat, busset ja togat fievrridit duháhiid ođđasat mátkkošteddjiid. Stálut fatnasis ja šalddi alde dahket vuordinbottu speallanbottun.",
      idea: "Mearrastállu mii savvá fearjja njuni luhtte, bileahttastállu busseboddosajis ja tunnelstállu man deaivvat dušše togas.",
      types: ["Fearjásearvvit", "Jođánisfatnasat", "Guovllubusset", "Togat", "Gávpotjohtolat", "Šalddit ja terminálat"],
    },
    cafes: {
      name: "Kaféat ja láibbohagat",
      short: "Ođđa bullat, liekkus kaffe — ja stállu uvssa luhtte.",
      lead: "Okta stállu du kaféa olggobealde geasuha speallid sisa kaffii, vafeliidda ja kanelbulláide. Sii sáhttet diŋgot ovdagihtii Vippsain ja viežžat go bohtet.",
      idea: "Láibbustállu jáffuiguin njuni alde, mii hádjá kanelbullaid láse čađa.",
      types: ["Báikkálaš kaféat", "Láibbohagat", "Kaffebassanbáikkit", "Láibbohat- ja kaffeossodagat", "Jiekŋakiosat", "Vafelbuvssat"],
    },
    saunas: {
      name: "Sávnnat",
      short: "Liggen bivddu maŋŋá.",
      lead: "Galmma beaivvi maŋŋá bálggis ii mihkkege leat buoret go sávdni vuona guoras. Sávdnestállu doalvu speallid du uvssa lusa, ja sii sáhttet diŋgot áiggi Vippsain.",
      idea: "Ilolaš stállu ráidalas liinniin, mii suovvá dekkas ja hástala buohkaid njuiket vuotnii.",
      types: ["Báikkálaš sávnnat", "Čáhcesávnnat", "Vuotnasávnnat", "Sávdnesearvvit", "Spá ja basadanviesut", "Basadanstámpat"],
    },
    shops: {
      name: "Unna gávppit ja báikkálaš buvttadeaddjit",
      short: "Unna gávpi, stuorra fuobmáŋ.",
      lead: "Stálubivdit liikojit váldit juoidá ruoktot. Okta stállu du gávppi luhtte bidjá du kártii buohkaide geat vuodjet meattá.",
      idea: "Gávpestállu gurpin dievva muorjemeasttus, vuostás ja ullosuohkuiguin.",
      types: ["Dállogávppit", "Muitto- ja duodjegávppit", "Vuolabassanbáikkit ja destillerat", "Bivdo- ja olgoeallingávppit", "Girje- ja attáldatgávppit", "Biebmo-, sport- ja ruovdegávppit"],
    },
  },
};

export default se;
